import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ActiveAccountRestriction } from '../../Models/Models/Account/Restrictions/ActiveAccountRestriction';

declare var IS_RUNNING_IN_APP_POOL;

export class CustomerRestrictionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(actorIds: Array<number>): Promise<Array<ActiveAccountRestriction>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/CustomerRestriction/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { actorIds: actorIds }

    return AjaxWrapper.get<Array<ActiveAccountRestriction>, any>(url, data);
  }
}

